module.exports = __webpack_public_path__ + "img/img_button.7a0852b2.png";